export const getRelativeRoutePath = (p: string): string => {
  const parts = p.split("/");
  return parts[parts.length - 1] ?? "";
};

export const getRelativeRouteRoot = (p: string): string => {
  const parts = p.split("/");
  return parts[1] ?? "";
};
